export default [
    {
        path: 'relatorio-procedimento',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-procedimento' */
            '@/views/ambulatorio/relatorio-procedimento/Index'
        ),
        redirect: 'relatorio-procedimento/index',
        children: [
            {
                name: 'ambulatorio-relatorio-procedimento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-procedimento' */
                    '@/views/ambulatorio/relatorio-procedimento/List.vue'
                ),
            },
        ],
    },
]